import { INotification } from 'src/interfaces';
import { NotificationsActionType } from '../action-types';
import { NotificationsAction } from '../actions';

interface NotificationsState {
  loading: boolean;
  error: string | null;
  data: { notifications: INotification[] };
}

const initialState = {
  loading: false,
  error: null,
  data: { notifications: [] },
};

const reducer = (state: NotificationsState = initialState, action: NotificationsAction): NotificationsState => {
  switch (action.type) {
    case NotificationsActionType.GET_NOTIFICATIONS:
      return { loading: true, error: null, data: { notifications: [] } };
    case NotificationsActionType.GET_NOTIFICATIONS_SUCCESS:
      return { loading: false, error: null, data: action.payload };
    case NotificationsActionType.GET_NOTIFICATIONS_FAILURE:
      return {
        loading: false,
        error: action.payload,
        data: { notifications: [] },
      };
    default:
      return state;
  }
};

export default reducer;
